import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

// Fournisseur de carte interchangeable : OpenStreetMap par défaut ; Google Maps pourra être ajouté ici (clé Norea) sans toucher aux écrans.
export const MAP_PROVIDERS = {
  osm: { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", attribution: "&copy; OpenStreetMap · adresses : Base Adresse Nationale" },
};
export const FRANCE = { center: [46.6, 2.4], zoom: 6 };

export const TYPE_STYLE = {
  pose: "bg-emerald-50 text-emerald-800 border-emerald-200", sav: "bg-sky-50 text-sky-800 border-sky-200",
  desinstallation: "bg-orange-50 text-orange-800 border-orange-200", visite: "bg-violet-50 text-violet-800 border-violet-200", autre: "bg-slate-50 text-slate-700 border-slate-200",
};
export const TYPE_COLOR = { pose: "#15803D", sav: "#0369A1", desinstallation: "#C2410C", visite: "#7C3AED", autre: "#475569" };

export function usePlanningOptions() {
  const [opts, setOpts] = useState(null);
  const load = useCallback(() => api.get("/planning/options").then((r) => setOpts(r.data)).catch(() => setOpts(null)), []);
  useEffect(() => { load(); }, [load]);
  return [opts, load];
}

const pad = (n) => String(n).padStart(2, "0");
export const toLocal = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
export const fromLocal = (s) => new Date(`${s}:00`);
export const frDate = (s) => (s ? fromLocal(s.slice(0, 16)).toLocaleDateString("fr-FR", { weekday: "short", day: "2-digit", month: "short", year: "numeric" }) : "—");
export const frTime = (s) => (s ? s.slice(11, 16) : "");
export const errMsg = (e, fb) => { const d = e?.response?.data?.detail; return (typeof d === "string" ? d : d?.message) || fb; };

export const openOrdre = async (rid) => {
  const r = await api.get(`/planning/rdv/${rid}/ordre.pdf`, { responseType: "blob" });
  window.open(URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })), "_blank");
};

export const RDV_CHANGED = "norea:rdv-changed";
export const emitRdvChanged = () => window.dispatchEvent(new CustomEvent(RDV_CHANGED));
